const DeviceService = {
	isDesktop: () => navigator.maxTouchPoints === 0
};

export default DeviceService;